<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowWorkInformationForm" :model="formData" class="full-width-input" :disable="readOnly"
       style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="内容" prop="WorkInformation.workContent">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.WorkInformation.workContent"
              type="textarea"
              :autosize="{minRows: 2, maxRows: 4}"
              :clearable="true" placeholder="内容"
            />
            <span class="input-item input-label" v-else>{{formData.WorkInformation.workContent}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="图片" prop="WorkInformation.attachedFiles">
<!--            <el-upload v-if="!readOnly"-->
<!--              class="upload-image-item upload-image-multi" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/workInformation/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: true}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              list-type="picture-card" :file-list="flowWorkInformationForm.attachedFiles.impl.fileList" :limit="flowWorkInformationForm.attachedFiles.impl.maxCount"-->
<!--              :show-file-list="true">-->
<!--              <i class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <img v-for="item in flowWorkInformationForm.attachedFiles.impl.fileList" :key="item.url"-->
<!--                class="table-cell-image" :src="item.url" />-->
<!--            </template>-->

            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/WorkInformation/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: true}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowWorkInformationForm.attachedFiles.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowWorkInformationForm.attachedFiles.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.WorkInformation.attachedFiles, {id: formData.WorkInformation.id,
                  fieldName: 'attachedFiles', asImage: true})"
                        :preview-src-list="getPictureList(formData.WorkInformation.attachedFiles, {id: formData.WorkInformation.id, fieldName: 'attachedFiles', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作地点" prop="WorkInformation.workLocation">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.WorkInformation.workLocation"
              :clearable="true" placeholder="工作地点"
            />
            <span class="input-item input-label" v-else>{{formData.WorkInformation.workLocation}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { WorkInformationController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowWorkInformation';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'flowWorkInformationForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        WorkInformation: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          createUserName: undefined,
          workType: undefined,
          workSubject: undefined,
          workContent: undefined,
          attachedFiles: undefined,
          viewNumber: undefined,
          workLocation: undefined,
          longitude: undefined,
          latitude: undefined,
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      flowWorkInformationForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        attachedFiles: {
          impl: new UploadWidget(3)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowWorkInformationForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return WorkInformationController.startAndTakeUserTaskFlowWorkInformation(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              workInformationDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.flowWorkInformationForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.workInformationDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return WorkInformationController.submitUserTaskFlowWorkInformation(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          workInformationDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        WorkInformationController.startAndSaveDraftFlowWorkInformation(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.WorkInformation
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.WorkInformation[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? WorkInformationController.viewTaskBusinessDataFlowWorkInformation(this, params) : WorkInformationController.viewHistoricTaskBusinessDataFlowWorkInformation(this, params)
        }
        httpCall.then(res => {
          this.formData.WorkInformation = { ...res.data };
          let attachedFilesDownloadParams = {
            id: this.formData.WorkInformation.id,
            fieldName: 'attachedFiles',
            asImage: true
          }
          this.flowWorkInformationForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.WorkInformation.attachedFiles, attachedFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowWorkInformationForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 更新工作日志表单
     */
    refreshFlowWorkInformationForm (reloadData = false) {
      if (!this.flowWorkInformationForm.isInit) {
        // 初始化下拉数据
      }
      this.flowWorkInformationForm.isInit = true;
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowWorkInformationForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.WorkInformation.attachedFiles = this.fileListToJson(this.flowWorkInformationForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.flowWorkInformationForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.WorkInformation.attachedFiles = this.fileListToJson(this.flowWorkInformationForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
